<div id="not-loggedin" class="main-container verv-theme">
    <div class="container " style="padding:0">
      <router-outlet name="master"></router-outlet>
    </div>
</div>
